export interface TeamMember {
  id: string;
  userId: string;
  email: string;
  firstName: string | null;
  role: 'owner' | 'admin' | 'member';
  joinedAt: string;
}

export interface Invitation {
  id: string;
  email: string;
  role: 'admin' | 'member';
  status: 'pending' | 'accepted' | 'expired' | 'revoked';
  expiresAt: string;
  createdAt: string;
  invitedBy: {
    email: string;
    firstName: string | null;
  };
}

export type TabKey = 'members' | 'invitations' | 'settings' | 'activity';

export interface ConfirmModalState {
  isOpen: boolean;
  title: string;
  message: string;
  confirmText: string;
  variant: 'danger' | 'warning';
  onConfirm: () => Promise<void>;
}

export const roleColors: Record<string, string> = {
  owner: 'bg-purple-100 text-purple-700 dark:bg-purple-900/30 dark:text-purple-400',
  admin: 'bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-400',
  member: 'bg-gray-100 text-gray-700 dark:bg-gray-800 dark:text-gray-400',
};
